export default function CardScroll() {
    if (window.innerWidth > 992) {
      return;
    }

    var stackCards = document.querySelectorAll('[card-scroll]'),
        intersectionObserverSupported = ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype);

    const elements = document.querySelectorAll('[card-scroll-item]');
    elements.length && elements[0].classList.add('is-pinned');

    let offsetYpos = [];

    if(stackCards.length > 0 && intersectionObserverSupported) { 
        elements.forEach((element, idx) => {
            const observer = new IntersectionObserver(
            ([e]) => {
              const target = elements[idx+1];

              offsetYpos[idx] = 80*idx;

              e.target.setAttribute('style', 'transform: translateY('+offsetYpos[idx]+'px)');          

              if (target) {                 
                  target.classList.toggle("is-pinned", e.boundingClientRect.top <= offsetYpos[idx] + e.target.offsetHeight);
                  e.target.classList.toggle('is-pinned',  e.boundingClientRect.top > offsetYpos[idx] + e.target.offsetHeight);
              }
            },
            { threshold: [1] }
          );
            observer.observe(element);
        });
    }
}